import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import useLocales from '../../../hooks/useLocales';
import { deleteFTVehicle, fetchFTVehicles } from '../../../redux/slices/ftVehiclesSlice';

FTVehiclesDeleteModal.propTypes = {
  passedData: PropTypes.any,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default function FTVehiclesDeleteModal({ passedData, open, handleClose }) {
  const dispatch = useDispatch();
  const { translate } = useLocales();

  const handleDelete = () => {
    dispatch(deleteFTVehicle({ device: window.navigator.userAgent, id: passedData })).then(() => {
      dispatch(fetchFTVehicles());
    });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="delete-vehicle">
      <DialogTitle id="delete-vehicle">{translate('deletePopupTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{translate('deletePopupMessageOneItem')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" autoFocus onClick={handleClose}>
          {translate('cancel')}
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete} autoFocus>
          {translate('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
